import './App.css';
import React, { useEffect, useState } from 'react';
import Game from './Game';
import Modal from './Modal';
import Instructions from './Instructions';
import axios from 'axios';
import { Button, NonIdealState, Spinner } from '@blueprintjs/core';

const SERVER_BASE_URL = process.env.REACT_APP_SERVER_BASE_URL !== "" ? process.env.REACT_APP_SERVER_BASE_URL : "http://localhost:8080";

function App() {
  const [currentGame, setCurrentGame] = useState();
  const [game, setGame] = useState()
  const [name, setName] = useState();
  const [highscore, setHighscore] = useState();
  const [miningRate, setMiningRate] = useState(0);
  const [showInstructions, setShowInstructions] = useState(false);

  const getDailyGame = () => {
    axios.get(`${SERVER_BASE_URL}/game/current`)
    .then(resp => {
      setGame({
        m: resp.data.game.height,
        n: resp.data.game.width,
        units: ["Sheep", "Giraffe", "Elephant", "Monkey", "Peacock", "Duck"],
        objects: resp.data.game.objects,
      });
      setName(resp.data.time);
      setHighscore(resp.data.highscore);
    })
    .catch(err => {
      console.log(err)
      setGame(null);
    });
  }

  useEffect(() => {
    getDailyGame();
  }, [])

  return (
    <div className="App">
      <Button icon='info-sign' text='Instructions' onClick={() => setShowInstructions(true)} />
      <div style={{ width: '100%', maxWidth: '380px', display: 'flex', justifyContent: 'space-between' }}><span>{name}</span><span>{highscore !== undefined ? `Highscore: ${highscore.toFixed(2)}` : ''}</span></div>
      {game === undefined ?
        <div style={{height: '350px'}}>
          <NonIdealState icon={<Spinner />} title="Loading..." />
        </div> :
        game === null ? 
        <div style={{height: '350px'}}>
          <NonIdealState icon='warning-sign' title="Failed to get game">
            <Button icon='refresh' text='Retry' onClick={() => getDailyGame()} />
            </NonIdealState>
        </div> :
        <Game game={game} SetGame={setCurrentGame} SetMiningRate={setMiningRate} />
      }

      <Button text='Submit Score' onClick={() => {
        axios.post(`${SERVER_BASE_URL}/game/current`, { 'time': name, 'game': currentGame, miningRate })
          .then(resp => {
            const newHighscore = resp.data.highscore;
            alert(`Score Submitted! ${miningRate.toFixed(2) === newHighscore.toFixed(2) ? "You hold the current highscore!" : ''}`);
            setHighscore(resp.data.highscore);
          })
          .catch(err => console.log(err));
      }} />

      {showInstructions && <Modal closeModal={() => { setShowInstructions(false) }}>
        <Instructions />
      </Modal>}
    </div>
  );
}

export default App;
